import { useAtom } from "jotai";

import { $draftCommitMessage } from "../../internal/git";

export const useDraftCommitMessage = () => {
	return useAtom($draftCommitMessage);
};
